<template>
  <v-row>
    <v-col cols="12">
      <v-chip-group mandatory active-class="primary--text" v-model="imageType">
        <v-chip
          label
          color="rgb(255, 255, 255, 0)"
          class="px-5 py-4"
          value="displayImageURL"
          >Profile Image</v-chip
        >
        <v-chip
          label
          color="rgb(255, 255, 255, 0)"
          class="px-5 py-4"
          value="reverseImageURL"
          >Feature Card</v-chip
        >
        <v-chip
          label
          color="rgb(255, 255, 255, 0)"
          class="px-5 py-4"
          value="backgroundImageURL"
          >Wallpaper</v-chip
        >
      </v-chip-group>
    </v-col>
    <v-col cols="12">
      <v-row>
        <!--Start: Profile Image-->
        <v-col cols="12" v-if="imageType == 'displayImageURL'">
          <v-row>
            <v-col cols="4">
              <div
                class="
                  fab
                  rounded-circle
                  outlined-border
                  d-flex
                  justify-center
                  align-center
                  cursor-pointer
                  font-weight-bold
                  text-center
                "
                style="width: 175px; height: 175px"
                v-ripple="{ center: true, class: 'rounded-circle' }"
                @click="UploadImageDialog = true"
              >
                <span class="grey--text"> + Add new image </span>
              </div>
              <UploadImageDialog
                :show="UploadImageDialog"
                isDisplayImage
                :previewType="imageType"
                @close="UploadImageDialog = false"
                @uploaded="handleUploaded"
                :businessCardRotatorObject="transientLinkInBio"
                :image="editImageURL"
                ref="uploadImageDialog"
              />
            </v-col>
            <v-col
              cols="4"
              v-for="(image, index) in imageList"
              :key="`displayImage${index}`"
            >
              <v-hover v-slot="{ hover }">
                <v-sheet
                  :class="[
                    { selected: transientLinkInBio.displayImageURL == image },
                    'circle d-flex justify-center align-center',
                  ]"
                  :outlined="
                    transientLinkInBio.displayImageURL == image ? false : true
                  "
                  width="175"
                  height="175"
                  @click="transientLinkInBio.displayImageURL = image"
                >
                  <v-img :src="image" class="circle" width="173" height="175">
                    <div
                      class="text-center mt-3"
                      v-show="
                        hover &&
                        !defaultImages.includes(image) &&
                        !(transientLinkInBio.displayImageURL == image)
                      "
                    >
                      <v-btn
                        :key="`edit${index}`"
                        fab
                        x-small
                        color="white"
                        class="mr-1"
                      >
                        <v-icon
                          :class="{ 'show-btns': hover }"
                          @click.stop="handleEdit(image, 'displayImageURL')"
                          color="secondary"
                        >
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                      <v-btn
                        :key="`delete${index}`"
                        @click.stop="handleDelete(image)"
                        fab
                        x-small
                        color="white"
                      >
                        <v-icon
                          :class="{ 'show-btns': hover }"
                          color="secondary"
                        >
                          mdi-trash-can
                        </v-icon>
                      </v-btn>
                    </div>
                  </v-img>
                </v-sheet>
              </v-hover>
            </v-col>
          </v-row>
        </v-col>
        <!--End: Profile Image-->

        <!--Start: Feature Card-->
        <v-col cols="12" v-if="imageType == 'reverseImageURL'">
          <v-row>
            <v-col cols="12">
              <template
                v-if="
                  transientLinkInBio.cardBackUrl != '' || showFeatureCardLink
                "
              >
                <div>
                  <v-btn
                    text
                    color="primary"
                    class="mb-3"
                    @click="handleRemoveLinkFromFeatureCard"
                    ><v-icon>mdi-close</v-icon>Remove url from the card
                  </v-btn>
                  <v-text-field
                    dense
                    outlined
                    v-model="transientLinkInBio.cardBackUrl"
                  >
                  </v-text-field>
                </div>
              </template>

              <v-btn
                text
                color="primary"
                v-else
                @click="showFeatureCardLink = true"
                ><v-icon>mdi-plus</v-icon>Add a url to the card
              </v-btn>
            </v-col>

            <v-col cols="4">
              <v-card
                height="100%"
                width="100%"
                class="
                  fab
                  outlined-border
                  d-flex
                  justify-center
                  align-center
                  cursor-pointer
                "
                :ripple="{ center: true }"
                @click="UploadImageDialog = true"
              >
                <v-card-text
                  class="grey--text font-weight-bold cursor-pointer text-center"
                  >+ Add new image</v-card-text
                >
              </v-card>
              <UploadImageDialog
                :previewType="imageType"
                :show="UploadImageDialog"
                @close="UploadImageDialog = false"
                @uploaded="handleUploaded"
                :businessCardRotatorObject="transientLinkInBio"
                :image="editImageURL"
                ref="uploadImageDialog"
              />
            </v-col>
            <v-col
              v-for="(image, index) in imageList"
              :key="`reverseImage${index}`"
              md="4"
            >
              <v-hover v-slot="{ hover }">
                <div>
                  <v-sheet
                    :class="
                      transientLinkInBio.reverseImageURL == image
                        ? 'selected'
                        : 'outlined-border'
                    "
                    height="100%"
                    width="100%"
                    rounded="lg"
                    @click="transientLinkInBio.reverseImageURL = image"
                  >
                    <v-img
                      :src="image"
                      :aspect-ratio="378 / 250"
                      style="border-radius: 7px !important"
                    >
                      <div
                        class="text-right mt-2 mr-2"
                        v-show="
                          hover &&
                          !defaultImages.includes(image) &&
                          !(transientLinkInBio.reverseImageURL == image)
                        "
                      >
                        <v-btn
                          :key="`edit${index}`"
                          @click.stop="handleEdit(image, 'reverseImageURL')"
                          fab
                          x-small
                          color="white"
                          class="mr-1"
                        >
                          <v-icon
                            :class="{ 'show-btns': hover }"
                            color="secondary"
                          >
                            mdi-pencil
                          </v-icon>
                        </v-btn>
                        <v-btn
                          :key="`delete${index}`"
                          @click.stop="handleDelete(image)"
                          fab
                          x-small
                          color="white"
                          class="mr-1"
                        >
                          <v-icon
                            :class="{ 'show-btns': hover }"
                            color="secondary"
                          >
                            mdi-trash-can
                          </v-icon>
                        </v-btn>
                      </div>
                    </v-img>
                  </v-sheet>
                </div>
              </v-hover>
            </v-col>
          </v-row>
        </v-col>
        <!--End: Feature Card-->

        <!--Start: Wallpaper-->
        <v-col cols="12" v-if="imageType == 'backgroundImageURL'">
          <v-row>
            <v-col cols="4">
              <v-card
                class="
                  d-flex
                  outlined-border
                  justify-center
                  align-center
                  cursor-pointer
                "
                height="100%"
                width="100%"
                :ripple="{ center: true }"
                @click="UploadImageDialog = true"
              >
                <v-card-text
                  class="grey--text font-weight-bold cursor-pointer text-center"
                  >+ Add new image</v-card-text
                >
              </v-card>
              <UploadImageDialog
                :previewType="imageType"
                :show="UploadImageDialog"
                @close="UploadImageDialog = false"
                @uploaded="handleUploaded"
                :businessCardRotatorObject="transientLinkInBio"
                :image="editImageURL"
                ref="uploadImageDialog"
              />
            </v-col>
            <v-col
              v-for="(image, index) in imageList"
              :key="`backgroundImage${index}`"
              md="4"
            >
              <v-hover v-slot="{ hover }">
                <v-sheet
                  :class="
                    transientLinkInBio.backgroundImageURL == image
                      ? 'selected'
                      : 'outlined-border'
                  "
                  rounded="lg"
                  height="100%"
                  width="100%"
                  @click="transientLinkInBio.backgroundImageURL = image"
                >
                  <v-img
                    :src="image"
                    :aspect-ratio="378 / 250"
                    style="border-radius: 7px !important"
                  >
                    <div
                      class="text-right mr-2 mt-2"
                      v-show="
                        hover &&
                        !defaultImages.includes(image) &&
                        !(transientLinkInBio.backgroundImageURL == image)
                      "
                    >
                      <v-btn
                        :key="`edit${index}`"
                        @click.stop="handleEdit(image, 'backgroundImageURL')"
                        fab
                        x-small
                        color="white"
                        class="mr-1"
                      >
                        <v-icon
                          :class="{ 'show-btns': hover }"
                          color="secondary"
                        >
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                      <v-btn
                        :key="`delete${index}`"
                        @click.stop="handleDelete(image)"
                        fab
                        x-small
                        color="white"
                      >
                        <v-icon
                          :class="{ 'show-btns': hover }"
                          color="secondary"
                        >
                          mdi-trash-can
                        </v-icon>
                      </v-btn>
                    </div>
                  </v-img>
                </v-sheet>
              </v-hover>
            </v-col>
            <!--End: Wallpaper-->
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UploadImageDialog from "@/components/LinkInBio/UploadImageDialog";

export default {
  data() {
    return {
      imageType: "displayImageURL",
      defaultImages: [
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_1.png?alt=media&token=eaaa4308-db9d-4b4d-9ad4-828ac7454ab7",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_2.png?alt=media&token=e2112092-7b35-4a75-987f-dd542ce8b9e2",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_3.png?alt=media&token=30456377-366c-4a8d-aaeb-2c3db9568210",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_4.png?alt=media&token=c9111f1a-c150-4847-b2ef-2fb657d1beff",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_5.png?alt=media&token=fd78d284-470e-4bd6-9b7e-cb7ebad926f0",
        "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/businessCardPresetBackgrounds%2FDefault_6.png?alt=media&token=2f55f010-cbec-4d89-9058-9f43a397a7bb",
      ],
      imageURL: "",
      UploadImageDialog: false,
      imageList: [],
      showFeatureCardLink: false,
      transparent: "rgba(255, 255, 255, 0)",
      editImageURL: "",
    };
  },
  provide() {
    return {
      previewType: () => this.imageType,
    };
  },

  components: {
    UploadImageDialog,
  },
  created() {
    this.imageList = this.getImageListBasedOnType(
      this.transientLinkInBio.displayImageURL
    );
  },
  watch: {
    imageType: function (imageType) {
      this.initImageList(imageType);
    },
    "businessProfile.imageURLs": function () {
      this.initImageList(this.imageType);
    },
  },
  computed: {
    ...mapGetters(["linkInBio", "businessProfile", "transientLinkInBio"]),
  },
  methods: {
    ...mapActions(["updateBusinessProfileDetails", "showSnackbar"]),
    initImageList(imageType) {
      if (imageType == "displayImageURL")
        this.imageList = this.getImageListBasedOnType(
          this.transientLinkInBio.displayImageURL
        );
      else if (imageType == "reverseImageURL")
        this.imageList = this.getImageListBasedOnType(
          this.transientLinkInBio.reverseImageURL
        );
      else
        this.imageList = this.getImageListBasedOnType(
          this.transientLinkInBio.backgroundImageURL
        );
    },
    handleUploaded(downloadURL) {
      this.UploadImageDialog = false;
      if (this.imageType == "displayImageURL")
        this.transientLinkInBio.displayImageURL = downloadURL;
      else if (this.imageType == "reverseImageURL")
        this.transientLinkInBio.reverseImageURL = downloadURL;
      else this.transientLinkInBio.backgroundImageURL = downloadURL;
    },
    getImageListBasedOnType(selectedImage) {
      let imageList = [];
      if (selectedImage != "" && selectedImage != undefined) {
        //Push all default images to imageList except selectedImage
        imageList = this.defaultImages.filter((imageURL) => {
          return imageURL != selectedImage;
        });
        //Add selected image at index 0
        imageList.unshift(selectedImage);
      } else imageList = [...this.defaultImages];
      if (
        this.businessProfile.imageURLs?.length != 0 &&
        this.businessProfile.imageURLs != undefined
      ) {
        let insertAtIndex = imageList.indexOf(selectedImage) == -1 ? 0 : 1;
        //Insert images uploaded by user at second index onwards.
        imageList.splice(
          insertAtIndex,
          0,
          ...this.businessProfile.imageURLs?.filter((imageURL) => {
            return imageURL != selectedImage;
          })
        );
      }
      return imageList;
    },
    handleRemoveLinkFromFeatureCard() {
      this.showFeatureCardLink = false;
      this.transientLinkInBio.hasFeatureCardLink = false;
      this.transientLinkInBio.cardBackUrl = "";
    },
    async handleDelete(imageURL) {
      try {
        this.businessProfile.imageURLs = this.businessProfile.imageURLs.filter(
          (image) => {
            return image != imageURL;
          }
        );
        await this.updateBusinessProfileDetails({
          imageURLs: this.businessProfile?.imageURLs,
        });
        this.showSnackbar({ show: true, text: "Deleted successfully!" });
      } catch (err) {
        console.log("Error occurred while deleting an uploaded image: ", err);
        this.showSnackbar({
          show: true,
          text: "Could not delete image, please try again!",
        });
      }
    },
    async handleEdit(image, imageType) {
      this.editImageURL = image;
      this.imageType = imageType;

      //Fetch the image from url, convert to blob
      let res = await fetch(image);
      let blob = await res.blob();
      this.$refs.uploadImageDialog.fileAdded(blob);
      this.UploadImageDialog = true;
    },
  },
};
</script>

<style scoped>
.selected {
  /* outline: 3px solid #f15f31; */
  outline: 3px solid #f15f31;
  outline-offset: 3px;
}

.circle {
  border-radius: 50%;
  position: relative;
}

.cursor-pointer {
  cursor: pointer !important;
}

.outlined-border {
  border: 1px solid #e0e0e0;
}
::v-deep .show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
</style>
